import { render, staticRenderFns } from "./UiIcon.vue?vue&type=template&id=dd34be7e&scoped=true&"
import script from "./UiIcon.vue?vue&type=script&lang=js&"
export * from "./UiIcon.vue?vue&type=script&lang=js&"
import style0 from "./UiIcon.vue?vue&type=style&index=0&id=dd34be7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd34be7e",
  null
  
)

export default component.exports